<template>
  <FormSelect 
    :value="value"
    @input="$emit('input', $event)"
    :options="options"
    :field="field"
    :placeholder="placeholder"
    :readonly="readonly"
    :note="note"
    :loading="loading"
  />
</template>

<script>
export default {
  name: 'FormLocationStateSelect',
  props: {
    value: [String, Number],
    placeholder: String,
    field: String,
    readonly: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    note: String,
    countryCode: String,
  },
  data() {
    return {
      // For now, defaults to Australian states
      options: [
        { name: 'None Selected', value: null },
        { name: 'ACT', value: 'ACT' },
        { name: 'New South Wales', value: 'NSW' },
        { name: 'Northern Territory', value: 'NT' },
        { name: 'Queensland', value: 'QLD' },
        { name: 'South Australia', value: 'SA' },
        { name: 'Tasmania', value: 'TAS' },
        { name: 'Victoria', value: 'VIC' },
        { name: 'Western Australia', value: 'WA' }
      ]
    }
  }
}
</script>